import { createPluginFactory } from '@udecode/plate';

import { withMicroTask } from './withMicroTask';

export const ELEMENT_MICRO_TASK = 'micro_task';

import { SlatePluginsStore } from '../store';

export type onRemoveMicroTask = SlatePluginsStore['removeTask'];

export interface MicroTaskPlugin {
  onRemoveMicroTask: onRemoveMicroTask;
}

export const createMicroTaskPlugin = createPluginFactory<MicroTaskPlugin>({
  key: ELEMENT_MICRO_TASK,
  isElement: true,
  withOverrides: withMicroTask,
});
